module.exports = __webpack_public_path__ + "img/logo-1x.95f3f767.png";